import React from 'react'
import Hero from '../../components/Service/Servicesub/digitaldesign/Hero'
import Description from '../../components/Service/Servicesub/digitaldesign/Description'
import Technologies from '../../components/Service/Servicesub/digitaldesign/Technologies'
import Number from '../../components/Service/Servicesub/digitaldesign/Number'
const Digitaldesign = () => {
  return (
    <div>
            <Hero />
            <Description />
            <Technologies />
            <Number />
    </div>
  )
}

export default Digitaldesign
